// Capa de acceso a datos del módulo Página principal (constructor de home
// vía bloque_pagina — 4.3 del doc de BD). Los 4 bloques del alcance MVP
// (banner_principal, categorias, productos_destacados, footer) ya se crean
// automáticamente, inactivos, al dar de alta la empresa —
// fn_crear_empresa, 20260101000009_fn_crear_empresa.sql—, así que este
// módulo nunca necesita CREAR bloques, solo leerlos y actualizarlos.

import { supabaseClient } from '@plataforma/supabase-client';

export async function listarBloquesPagina() {
  return supabaseClient()
    .from('bloque_pagina')
    .select('id, estado, orden, configuracion, tipo_bloque:tipo_bloque_id(codigo, nombre)')
    .eq('pagina', 'home')
    .order('orden', { ascending: true });
}

/**
 * @param {string} bloqueId
 * @param {{ estado?: 'activo' | 'inactivo', configuracion?: object }} cambios
 */
export async function actualizarBloquePagina(bloqueId, cambios) {
  return supabaseClient()
    .from('bloque_pagina')
    .update(cambios)
    .eq('id', bloqueId)
    .select()
    .single();
}

/**
 * Intercambia el `orden` de dos bloques adyacentes — mover uno "arriba" es
 * intercambiar con el que tiene el orden inmediatamente menor. Con solo 4
 * bloques en el alcance MVP, dos updates simples son más que suficientes;
 * no hace falta drag-and-drop ni una función SQL de reordenamiento masivo.
 *
 * @param {{ id: string, orden: number }} bloqueA
 * @param {{ id: string, orden: number }} bloqueB
 */
export async function intercambiarOrdenBloques(bloqueA, bloqueB) {
  const cliente = supabaseClient();

  const { error: errorA } = await cliente
    .from('bloque_pagina')
    .update({ orden: bloqueB.orden })
    .eq('id', bloqueA.id);
  if (errorA) return { error: errorA };

  return cliente.from('bloque_pagina').update({ orden: bloqueA.orden }).eq('id', bloqueB.id);
}
